import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get("token") || "";
    const [pwd, setPwd] = useState("");
    const [pwd2, setPwd2] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        if (pwd !== pwd2) { setErr("Passwords don't match"); return; }
        setBusy(true); setErr("");
        try {
            await api.post("/auth/reset-password", { token, password: pwd });
            navigate("/login?reset=1");
        } catch (e2) {
            setErr(formatApiErrorDetail(e2.response?.data?.detail) || "Reset failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-paper p-8" data-testid="reset-page">
            <form onSubmit={submit} className="w-full max-w-sm space-y-5 grid-card p-8">
                <div>
                    <div className="overline mb-2">Account recovery</div>
                    <h1 className="font-heading text-3xl font-extrabold tracking-tighter">Set a new password</h1>
                    {!token ? <p className="text-sm text-neg mt-2">Missing reset token. Use the link from your email.</p> : null}
                </div>
                <div>
                    <label className="overline block mb-1.5">New password</label>
                    <input data-testid="reset-pwd" type="password" required minLength={6} value={pwd}
                        onChange={(e) => setPwd(e.target.value)} className="input-base" />
                </div>
                <div>
                    <label className="overline block mb-1.5">Confirm password</label>
                    <input data-testid="reset-pwd2" type="password" required minLength={6} value={pwd2}
                        onChange={(e) => setPwd2(e.target.value)} className="input-base" />
                </div>
                {err ? <div className="text-xs text-neg border border-neg/40 bg-neg/5 px-3 py-2 rounded-sm" data-testid="reset-error">{err}</div> : null}
                <button type="submit" disabled={busy || !token} data-testid="reset-submit" className="btn-primary w-full">
                    {busy ? "Saving…" : "RESET PASSWORD"}
                </button>
                <div className="text-xs text-muted2 pt-3 border-t border-rule">
                    <Link to="/login" className="underline">Back to sign in</Link>
                </div>
            </form>
        </div>
    );
}
